<template>
  <a-loading
    :loading="versionMeta.loading"
  >
    <version-form
      :version="{gameId: selectedGameId, ...version}"
      mode="create"
      @submit="handleSubmit"
    />
  </a-loading>
</template>

<script>
  import VersionForm from '@/components/VersionForm'
  import { useCreateVersion, useVersion } from '@/views/games/gameHooks'
  import { ALoading } from 'codefabrik-gui-vue'
  import { mapState } from 'vuex'

  export default {
    name: 'CopyVersion',
    components: { VersionForm, ALoading },
    mixins: [
      useVersion('version'),
      useCreateVersion('handleSubmit')
    ],
    computed: {
      ...mapState('game', ['selectedGameId']),
    },
  }
</script>

<style scoped>

</style>
